import { mobileLargeMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 15px;
  margin: 15px 0 0;
  flex-wrap: wrap;

  @media (${mobileXXLargeMax}) {
    justify-content: center;
  }
`;

export const Pill = styled(Link)`
  display: flex;
  background-color: ${({ theme }) => theme.background};
  border-radius: 30px;
  border: 1px solid ${({ theme }) => theme.keyline};
  color: ${({ theme }) => theme.textDark};
  text-align: left;
  align-items: center;
  justify-content: center;
  padding: 0 3px 0 15px;
  font-weight: bold;
  font-size: 16px;
  height: 52px;

  span {
    padding: 0 15px;
    text-align: center;
  }

  button {
    background-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.white};
    border-radius: 30px;
    height: calc(100% - 6px);
    padding: 0 20px;
    font-size: 16px;
    font-weight: 600;
  }

  @media (${mobileLargeMax}) {
    width: 100%;
    justify-content: space-between;
  }
`;
